import _ from 'lodash';
import checkMatchingStatus from './checkMatchingStatus';

function changeRequestLogic(currentBlockChange, cr, a, cr2, a2, block) {
  let changeRequests = cr;
  let changeRequests2 = cr2;
  let accepts = a;
  let accepts2 = a2;

  if (changeRequests.length > 0) {
    let filteredReqest = null;
    if (block.name === 'Licensing Permissions') {
      filteredReqest = _.filter(changeRequests, (change) =>
        _.isEqual(
          currentBlockChange
            ? _.sortBy(JSON.parse(currentBlockChange.options).licenserIds)
            : [],
          _.sortBy(change.changes.licenserIds)
        )
      );
      changeRequests = _.filter(
        changeRequests,
        (change) =>
          !_.isEqual(
            currentBlockChange
              ? _.sortBy(JSON.parse(currentBlockChange.options).licenserIds)
              : [],
            _.sortBy(change.changes.licenserIds)
          )
      );
    } else {
      filteredReqest = _.filter(changeRequests, (change) =>
        checkMatchingStatus(
          change.changes,
          currentBlockChange ? JSON.parse(currentBlockChange.options) : [],
          true
        )
      );
      changeRequests = _.filter(changeRequests, (change) =>
        checkMatchingStatus(
          change.changes,
          currentBlockChange ? JSON.parse(currentBlockChange.options) : [],
          false
        )
      );
    }

    if (filteredReqest.length > 0) {
      filteredReqest.forEach((request) => {
        request.users.forEach((user) => {
          accepts.push({ user });
        });
      });
    }
  }

  if (changeRequests2.length > 0) {
    const filteredReqest = _.filter(changeRequests2, (change) =>
      checkMatchingStatus(
        change.changes,
        currentBlockChange ? JSON.parse(currentBlockChange.options) : [],
        true
      )
    );
    changeRequests2 = _.filter(changeRequests2, (change) =>
      checkMatchingStatus(
        change.changes,
        currentBlockChange ? JSON.parse(currentBlockChange.options) : [],
        false
      )
    );

    if (filteredReqest.length > 0) {
      filteredReqest.forEach((request) => {
        request.users.forEach((user) => {
          accepts2.push({ user });
        });
      });
    }
  }

  return { changeRequests, accepts, changeRequests2, accepts2 };
}

export default changeRequestLogic;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/changeRequestLogic.js